import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const uploadInvoice = createApiThunk<string, { uploadId: string; invoice: File }>(
  "invoices/uploadInvoice",
  async ({ invoice }: { invoice: File }, { extra: { studentRepository } }) => {
    return studentRepository!.uploadInvoice(invoice);
  },
);

export const resetUploadInvoice = createAction("invoices/resetUploadInvoice");
export const resetUploadInvoiceForId = createAction<string>("invoices/resetUploadInvoiceForId");
